export default __webpack_public_path__ + "static/maoLuz-7d48c87c337fd5f3db14e969e6225975.png";